import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { DataTablesResponse } from '../models/datatables';
import { StihlEventDayDTO } from '../models/stihl-event-dto';
import { Select2Data } from 'ng-select2-component';
import { identifierName } from '@angular/compiler';

@Injectable({
  providedIn: 'root'
})

export class EventDayService {

  private pathAPI = environment.urlAPI;
  private controller = "StihlEventDay/";

  constructor(private http: HttpClient) { }

  public get(id: string): Observable<StihlEventDayDTO> {
    return this.http.get<StihlEventDayDTO>(this.pathAPI + this.controller + id);
  }

  public post(data: FormData): Observable<any> {
    return this.http.post<any>(this.pathAPI + this.controller, data);
  }

  public put(id: string, data: FormData): Observable<any> {
    return this.http.put<any>(this.pathAPI + this.controller + id, data);
  }

  public changeStatus(id: string, idStatus: number): Observable<any> {
    return this.http.put<any>(this.pathAPI + this.controller + 'ChangeStatus/' + id + '/' + idStatus, null);
  }

  public getDataTable(data: any, idType: string): Observable<DataTablesResponse> {
    return this.http.post<DataTablesResponse>(this.pathAPI + this.controller + 'GetDataTable/' + idType, data);
  }

  public getGallery(): Observable<Select2Data> {
    return this.http.get<Select2Data>(this.pathAPI + this.controller + 'GetGallery');
  }

  public getPoll(): Observable<Select2Data> {
    return this.http.get<Select2Data>(this.pathAPI + this.controller + 'GetPoll');
  }

  public GetStihlEventDayLst(idEvent: string): Observable<StihlEventDayDTO[]> {
    return this.http.get<StihlEventDayDTO[]>(this.pathAPI + this.controller + 'GetStihlEventDayLst/' + idEvent);
  }

}
